<template>
  <div class="invoice-period-table">
    <h3>{{ title }}</h3>
    <table class="table" v-if="lines && lines.length > 0">
      <thead>
        <tr>
          <th>Omschrijving</th>
          <th class="text-right">Stuksprijs</th>
          <th v-if="showBTW" class="text-right">BTW</th>
          <th v-if="showAmount" class="text-right">Aantal</th>
          <th class="text-right">Totaal</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(line, index) in lines" :key="index" :class="{ 'discount-line': line.isDiscountLine }">
          <td :style="line.isDiscountLine ? 'color: #666; font-size: 0.9em;' : ''">{{ line.name }}</td>
          <td class="text-right" :style="line.isDiscountLine ? 'color: #666;' : ''">
            <span v-if="!line.isDiscountLine">€ {{ formatPrice(line.price || 0) }}</span>
          </td>
          <td v-if="showBTW" class="text-right" :style="line.isDiscountLine ? 'color: #666;' : ''">
            <span v-if="!line.isDiscountLine">{{ line.btw || 0 }}%</span>
          </td>
          <td v-if="showAmount" class="text-right" :style="line.isDiscountLine ? 'color: #666;' : ''">
            <span v-if="!line.isDiscountLine">{{ line.amount || 0 }}</span>
          </td>
          <td class="text-right" :class="{ 'discount-amount': line.isDiscountLine }">
            <span v-if="line.total < 0">-</span>€ {{ formatPrice(Math.abs(line.total || 0)) }}
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td :colspan="colspan"></td>
          <td class="text-right"><strong>€ {{ formatPrice(total || 0) }}</strong></td>
        </tr>
      </tfoot>
    </table>
    <div v-else class="no-lines">
      Geen regels beschikbaar voor deze factuur.
    </div>
  </div>
</template>

<script>
export default {
  name: 'InvoicePeriodTable',

  props: {
    title: {
      type: String,
      required: true
    },
    lines: {
      type: Array,
      required: true
    },
    showBTW: {
      type: Boolean,
      default: true
    },
    showAmount: {
      type: Boolean,
      default: true
    },
    isDeposit: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    colspan() {
      let count = 1; // Description column
      if (this.showBTW) count++;
      if (this.showAmount) count++;
      count++; // Price column
      return count;
    },

    total() {
      return (this.lines || []).reduce((sum, line) => sum + (line.total || 0), 0)
    }
  },

  methods: {
    formatPrice(value) {
      return Number(value || 0).toFixed(2)
    }
  }
}
</script>

<style scoped>
.invoice-period-table {
  width: 100%;
  margin-bottom: 2rem;
}

.table {
  width: 100%;
  border-collapse: collapse;
}

.table th,
.table td {
  padding: 0.75rem;
  border-bottom: 1px solid #dee2e6;
}

.table th {
  border-top: 1px solid #dee2e6;
  background-color: #f8f9fa;
}

.text-right {
  text-align: right;
}

tfoot tr td {
  border-top: 2px solid #dee2e6;
  font-weight: bold;
}

.no-lines {
  padding: 1rem;
  text-align: center;
  color: #666;
}

.discount-line {
  background-color: #f8f9fa;
}

.discount-amount {
  color: #d9534f;
  font-weight: 500;
}
</style>